import { defineStore } from 'pinia'
import { ref } from 'vue'
import { segmentApplicationsApi } from '@/api'

/**
 * How many membership applications are waiting for review, for the badge in
 * the sidebar. Polled like the refund queue: a reviewer should notice one
 * arriving without reloading.
 */
export const useApplicationQueueStore = defineStore('applicationQueue', () => {
  const pending = ref(0)
  let timer: number | null = null

  async function refresh(): Promise<void> {
    try {
      pending.value = (await segmentApplicationsApi.pendingCount()).pending ?? 0
    } catch {
      // A failure here must never interrupt what the user is doing.
      pending.value = 0
    }
  }

  function startPolling(intervalMs = 60_000): void {
    if (timer !== null) return
    void refresh()
    timer = window.setInterval(() => void refresh(), intervalMs)
  }

  function stopPolling(): void {
    if (timer !== null) {
      window.clearInterval(timer)
      timer = null
    }
  }

  return { pending, refresh, startPolling, stopPolling }
})
